import { RoomData } from '@/editor/data/room/Room';
import RoomEntity from '@/editor/entities/roomEntity';
import { EFaceType } from '@/editor/entities/type';
import { globalStores } from '@/editor/stores';

export class RoomManager {
  private _list: RoomEntity[] = [];

  constructor() {}

  getEntityById(id: string) {
    return this._list.find((entity) => entity.id === id);
  }

  get entities() {
    return this._list;
  }

  private removeRoomEntityByIndex(index: number) {
    const roomEntity = this._list[index];
    if (roomEntity) {
      roomEntity.dispose();
      this._list.splice(index, 1);
    }
  }

  private addRoomEntity(roomEntity: RoomEntity) {
    this._list.push(roomEntity);
  }

  update(roomDatas: RoomData[]) {
    this.updateRoomEntities(roomDatas);
  }

  forceUpdate() {
    this._list.forEach((entity) => {
      const { roomData, withRegion } = this._parseRoomData(globalStores.roomStore.getRoomData(entity.id));
      if (roomData) {
        entity.update({ ...roomData, forceUpdate: true }, withRegion);
      }
    });
  }

  private updateRoomEntities(roomDatas: RoomData[]) {
    const prevserveRoomEntities = roomDatas
      .map((roomData) => this.getEntityById(roomData.id))
      .filter((entity) => !!entity);
    // 删除旧数据
    for (let i = this._list.length - 1; i > -1; i--) {
      if (!prevserveRoomEntities.includes(this._list[i])) {
        this.removeRoomEntityByIndex(i);
      }
    }

    for (let i = 0; i < roomDatas.length; i++) {
      const { roomData, withRegion } = this._parseRoomData(roomDatas[i]);

      const entity = this.getEntityById(roomData.id);
      if (!entity) {
        const roomEntity = new RoomEntity(roomData, withRegion);
        this.addRoomEntity(roomEntity);
      } else {
        entity.update(roomData, withRegion);
      }
    }
  }

  updateEntity(id: string) {
    const { roomData, withRegion } = this._parseRoomData(globalStores.roomStore.getRoomData(id));

    if (!roomData) return;

    const entity = this.getEntityById(id);
    if (entity) {
      entity.update(roomData, withRegion);
    }
  }

  private _parseRoomData(roomData: undefined): { roomData: undefined; withRegion: boolean };
  private _parseRoomData(roomData: RoomData): { roomData: RoomData; withRegion: boolean };
  private _parseRoomData(roomData: RoomData | undefined): { roomData: RoomData | undefined; withRegion: boolean };
  private _parseRoomData(roomData: RoomData | undefined): { roomData: RoomData | undefined; withRegion: boolean } {
    if (!roomData)
      return {
        roomData,
        withRegion: false
      };
    const roomRegions = globalStores.regionStore.getRoomRegions(roomData.id);
    if (roomRegions.length > 1) {
      return {
        roomData: {
          ...roomData,
          materialInfo: globalStores.getDefaultMaterial({ type: EFaceType.FloorFace })
        },
        withRegion: true
      };
    } else {
      return {
        roomData,
        withRegion: false
      };
    }
  }
}
